var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnavEngagements(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 19.1667,
    height: 19.1667,
    viewBox: "0 0 19.1667 19.1667",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3333 14.1667H17.5V12.5C17.4999 11.435 16.8252 10.487 15.819 10.1381C14.8127 9.78926 13.696 10.1161 13.0367 10.9525M13.3333 14.1667H5M13.3333 14.1667V12.5C13.3333 11.9533 13.2283 11.4308 13.0367 10.9525M5 14.1667H0.833333V12.5C0.833411 11.435 1.50816 10.487 2.51438 10.1381C3.5206 9.78926 4.63736 10.1161 5.29667 10.9525M5 14.1667V12.5C5 11.9533 5.105 11.4308 5.29667 10.9525M5.29667 10.9525C5.92982 9.37022 7.46241 8.33275 9.16667 8.33275C10.8709 8.33275 12.4035 9.37022 13.0367 10.9525M11.6667 3.33333C11.6667 4.71312 10.5465 5.83333 9.16667 5.83333C7.78688 5.83333 6.66667 4.71312 6.66667 3.33333C6.66667 1.95355 7.78688 0.833333 9.16667 0.833333C10.5465 0.833333 11.6667 1.95355 11.6667 3.33333L13.3333 14.1667M18.3333 16.6667C18.3333 17.5865 17.5865 18.3333 16.6667 18.3333C15.7468 18.3333 15 17.5865 15 16.6667C15 15.7468 15.7468 15 16.6667 15C17.5865 15 18.3333 15.7468 18.3333 16.6667V16.6667M5 5.83333C5 6.75319 4.25319 7.5 3.33333 7.5C2.41347 7.5 1.66667 6.75319 1.66667 5.83333C1.66667 4.91347 2.41347 4.16667 3.33333 4.16667C4.25319 4.16667 5 4.91347 5 5.83333V5.83333",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnavEngagements);
export default __webpack_public_path__ + "static/media/unav-engagements.46bcf49bdf654c68d5e6bb4993a19412.svg";
export { ForwardRef as ReactComponent };